<template>
  <div id="data-list-list-view" class="data-list-container">
    <add
      :isSidebarActive="addPrompt"
      @closePrompt="toggleAddPrompt"
      :callBackFunction="callBackAdd"
    />
    <update
      :isSidebarActive="updatePrompt"
      @closeUpdate="toggleUpdatePrompt"
      :callBackFunction="getData"
      :model="model"
    />
    <vs-table ref="table" :max-items="10" search :data="data">
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div
          class="flex flex-wrap-reverse items-center data-list-btn-container"
        >
          <div
            @click="addPrompt = true"
            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Ajouter</span>
          </div>
          <div
            @click="getData()"
            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
          >
            <feather-icon icon="RefreshCwIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Actualiser</span>
          </div>
        </div>
      </div>

      <template slot="thead">
        <vs-th>Nom d'utilisateur</vs-th>
        <vs-th>Status</vs-th>
        <vs-th>Créé le</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td width="40%">
              <span class="">{{ tr.username }} </span>
            </vs-td>

            <vs-td>
              <vs-chip :color="tr.status =='1' ? 'success' : 'danger'">{{ tr.status == '1' ? 'Actif' : 'Inactif' }}</vs-chip>
            </vs-td>

            <vs-td width="20%">
              <p class="product-category">{{ tr.created_at }}</p>
            </vs-td>

            <vs-td width="20%" class="whitespace-no-wrap">
              <div class="flex">
                <div class="flex" @click="alter(tr)">
                  <feather-icon
                    icon="EditIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    class="mr-2"
                  />
                </div>

                <div class="flex" @click="lock(tr)" v-if="tr.status == '1'">
                  <feather-icon
                    icon="LockIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    class="mr-2"
                  />
                </div>
                <div class="flex" @click="unlock(tr)" v-if="tr.status == '0'">
                  <feather-icon
                    icon="UnlockIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    class="mr-2"
                  />
                </div>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <vs-pagination
      v-if="last_page && page"
      :total="last_page"
      v-model="page"
    ></vs-pagination>
  </div>
</template>

<script>
import Add from "./components/add";
import Update from "./components/update";

export default {
  name: "thirdparty",
  components: { Add, Update },
  data: () => ({
    page: 1,
    last_page: 1,
    data: [],
    addPrompt: false,
    updatePrompt: false,
    model: {},
  }),
  watch: {
    page(value) {
      this.getData(value);
    },
  },
  methods: {
    toggleAddPrompt(val = false) {
      this.addPrompt = val;
    },
    toggleUpdatePrompt(val = false) {
      this.updatePrompt = val;
    },
    alter(model) {
      this.model = model;
      this.updatePrompt = true;
    },
    lock(tr) {
      if (confirm("Voulez vous bloquer ce Third Party ?")) {
        this.$vs.loading();
        this.$http
          .post("/third/lock", {
            id: tr.id,
            //date: tr.planned_date
          })
          .then((response) => {
            let index = this.data.indexOf(tr);
            //this.data.splice(index, 1);
            this.data.forEach((element) => {
              if (element.id === tr.id) {
                element.status = '0';
              }
            });
            this.$vs.loading.close();
          })
          .catch((error) => {
            this.$vs.loading.close();
            console.log(error);
          });
      }
    },
    unlock(tr) {
      this.$vs.loading();
      this.$http
        .post("/third/unlock", {
          id: tr.id,
          //date: tr.planned_date
        })
        .then((response) => {
          let index = this.data.indexOf(tr);
          this.data.forEach((element) => {
              if (element.id === tr.id) {
                element.status = '1';
              }
            });
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    getData(page) {
      this.$vs.loading();
      this.$http
        .get("/third?page=" + this.page)
        .then((response) => {
          this.data = response.data.data;
          this.last_page = response.data.last_page;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    callBackAdd(data) {
      this.getData();
    },
  },
  mounted() {
    this.getData(this.page);
  },
};
</script>

<style scoped>
</style>
